import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",

      // alignItems: "stretch",
      // display: "flex",
      // flex: 1,
      // font: "16px/20px Garamond",
      // maxWidth: "100%",
      // padding: theme.spacing(4),
    },
    wrapper: {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadiusBig,
      flex: 1,
      maxWidth: "100%",
      paddingTop: "10%",
      position: "relative",
      textAlign: "center",
    },
    // logo: {
    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   width: "17%",
    // },
    // logoPlaceholder: {
    //   alignItems: "center",
    //   border: `1px solid ${theme.palette.grey[100]}`,
    //   display: "flex",
    //   flexDirection: "column",
    //   height: "22%",
    //   justifyContent: "center",
    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   padding: theme.spacing(1),
    //   width: "22%",
    // },
    // logoPlaceholderTitle: {},
    // logoPlaceholderSubtitle: {
    //   lineHeight: "1.2em",
    // },
    title: {},
    name: {},
    personalNumber: {},
    row: {},
    signatures: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      width: "70%",
    },
    signature: {
      borderTop: `1px solid ${theme.palette.common.black}`,
      flex: 1,
      fontSize: "60%",
      lineHeight: "1.3em",
      marginLeft: "2%",
      marginRight: "2%",
    },
    signaturePerson: {},
    signatureTitle: {},
    certifiedSince: {
      fontSize: "60%",
      fontStyle: "italic",
    },
    footer: {
      border: "1px solid red",
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Lucida Grande",
    padding: VoTheme.spacing(4),
  },
  decor: {
    borderBottom: `15px solid ${VoTheme.palette.primary.main}`,
    height: "100%",
    paddingLeft: VoTheme.spacing(4.5),
    paddingRight: VoTheme.spacing(4.5),
  },
  logoWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginBottom: 0,
    marginTop: 0,
  },
  logo: {
    height: "auto",
    width: 80,
  },
  title: {
    color: VoTheme.palette.common.black,
    fontSize: 36,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
  },
  subtitle: {
    color: VoTheme.palette.common.black,
    fontSize: 18,
    fontWeight: 700,
    textAlign: "center",
  },
  person: {
    // fontFamily: "Times-Italic",
    fontSize: 18,
    // fontWeight: 500,
    textAlign: "center",
  },
  personalNumber: {
    // fontFamily: "Times-Roman",
    fontSize: 12,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  centeredText: {
    fontSize: 12,
    lineHeight: 1.3,
    textAlign: "center",
  },
  topMargin: {
    marginTop: VoTheme.spacing(1.5),
  },
  // textWrapper: {
  //   marginTop: VoTheme.spacing(2),
  //   paddingTop: VoTheme.spacing(2),
  // },
  topBorder: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    marginTop: VoTheme.spacing(2),
    paddingTop: VoTheme.spacing(2),
  },
  text: {
    fontSize: 10,
    lineHeight: 1.3,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "left",
  },
  textCollege: {
    textAlign: "center",
    textTransform: "uppercase",
  },
  listItem: {
    paddingLeft: VoTheme.spacing(1),
  },
  listItemDot: {
    marginLeft: VoTheme.spacing(-10),
  },
  textContentPart: {
    marginTop: VoTheme.spacing(1),
  },
  footer: {
    fontSize: 10,
    marginBottom: VoTheme.spacing(2),
    marginTop: VoTheme.spacing(8),
    textAlign: "center",
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingLeft: VoTheme.spacing(7),
    paddingRight: VoTheme.spacing(7),
    width: "100%",
  },
  // signature: {
  //   borderTop: `1px solid ${VoTheme.palette.common.black}`,
  //   flex: 1,
  //   marginLeft: VoTheme.spacing(1),
  //   marginRight: VoTheme.spacing(1),
  //   maxWidth: 250,
  // },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 200,
    paddingTop: VoTheme.spacing(0.5),
  },
  signaturePerson: {
    fontSize: 10,
    textAlign: "center",
  },
  signatureTitle: {
    marginTop: VoTheme.spacing(0.5),
  },
  // educatorCertified: {
  //   marginTop: VoTheme.spacing(4),
  // },

  footerLogoWrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    marginBottom: VoTheme.spacing(1),
    marginLeft: VoTheme.spacing(-4.5),
    marginRight: VoTheme.spacing(-4.5),
    marginTop: VoTheme.spacing(2),
  },

  footerLogo: {
    height: "auto",
    width: 100,
  },
  uid: {
    bottom: 2,
    left: 0,
    position: "absolute",
  },
});
